export default __webpack_public_path__ + "assets/images/blackjack-19a4de944e82c7d10564ea81629630ff.svg";